import { render, staticRenderFns } from "./GroupRequestItem.vue?vue&type=template&id=59e1c7f0&scoped=true"
import script from "./GroupRequestItem.vue?vue&type=script&lang=js"
export * from "./GroupRequestItem.vue?vue&type=script&lang=js"
import style0 from "./GroupRequestItem.vue?vue&type=style&index=0&id=59e1c7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1c7f0",
  null
  
)

export default component.exports